import { useState } from "react";
import { StatusMessage } from "../../style/view.styles";
import { getUserCredentials, makeApiRequest } from "../../utils/RequestHandler";
import {
  FormContainer,
  StyledForm,
  StyledFormField,
  StyledLabel,
  StyledTextarea,
  Title,
} from "../../style/modal.form.style";
import { FaEnvelope } from "react-icons/fa";
import FullButton from "../Buttons/FullButton";

const StartTalentConversation = ({ talent, onSuccess }) => {
  const [formStatus, setFormStatus] = useState({ message: "", type: "" });
  const [submitting, setSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    recipient: talent?.email,
    text: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSendMessage = async () => {
    try {
      setSubmitting(true);
      const requestData = {
        ...formData,
      };

      let headers = {
        "Content-Type": "application/json",
      };
      const credentials = getUserCredentials();
      headers = { ...headers, ...credentials };
      const response = await makeApiRequest(
        "/send/text/",
        "POST",
        requestData,
        headers
      );
      if (response.success) {
        setFormStatus({
          message: "Message sent successfully!",
          type: "success",
        });
        if (onSuccess) onSuccess();
      } else {
        setFormStatus({
          message:
            response.result ??
            "An error occurred while submitting your request. Please try again.",
          type: "error",
        });
      }
    } catch (error) {
      console.error(error);
      setFormStatus({
        message: "An error occurred while sending message. Please try again.",
        type: "error",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <FormContainer>
      <Title>Start Conversation With {talent?.first_name}</Title>
      <StyledForm>
        <StyledFormField fullWidth>
          <StyledLabel>
            <FaEnvelope style={{ marginRight: 5 }} /> Send Note
          </StyledLabel>
          <StyledTextarea
            name="text"
            placeholder="You may type a short introduction."
            rows="5"
            value={formData.text}
            onChange={handleInputChange}
            required
          />
        </StyledFormField>
      </StyledForm>

      <FullButton
        type="submit"
        disabled={submitting}
        action={handleSendMessage}
        title={submitting ? "Sending..." : "Send"}
      />

      {formStatus.message && (
        <StatusMessage type={formStatus.type}>
          {formStatus.message}
        </StatusMessage>
      )}
    </FormContainer>
  );
};

export default StartTalentConversation;
